export default "__VITE_ASSET__5f22d274__"